import {
  Button,  
  Form,  
  FormGroup,  
  Input,  
  Label,  
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,  
} from 'reactstrap';

interface Props {
    isOpen: boolean;
    toggle: any;
  }
const InstructionDeatailsModal = (props: Props) => {
  const { isOpen, toggle} = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={'static'} size="md">
      <ModalHeader toggle={toggle}>Instruction</ModalHeader>

        <ModalBody>
          <div>                
              <div className="row justify-content-center">                    
                  <div className="col-md-9">
                      <div className="row justify-content-between">
                          <div>
                            <p className='text-danger'><b>------------Instruction Will be added soon!-----------</b></p> 
                          </div>
                      </div>
                  </div>                    
              </div>                                        
          </div>
        </ModalBody>

        <ModalFooter>
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
            </div>
        </ModalFooter>      
    </Modal>
  );
};

export default InstructionDeatailsModal;
